import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from "clsx";
import { useBreadcrumbsGroupContext } from "./BreadcrumbsGroup";
import { Button, buttonSlots } from "./Button";
import { ChevronRightOutline } from "../icons/icons";
import { SlotsProvider } from "../providers/SlotsProvider";
import { useDefaultProps } from "../providers/utils/defaultProps";
import { Stack } from "./Stack";
export const breadcrumbsButtonSlots = {
    separator: ChevronRightOutline,
};
export const breadcrumbsButtonClasses = {
    root: "MinervaBreadcrumbsButton-root",
    button: "MinervaBreadcrumbsButton-button",
};
export const BreadcrumbsButton = (props) => {
    const groupValue = useBreadcrumbsGroupContext();
    const { value, hideSeparator, slots, slotProps, color = "surface", colorSet, invertColors, className, ...rest } = useDefaultProps({ component: "BreadcrumbsButton", props });
    const isSelected = value && value === groupValue;
    return (_jsx(SlotsProvider, { baseSlots: { ...breadcrumbsButtonSlots, ...buttonSlots }, slots: slots, children: ({ separator: Separator, ...remainingSlots }) => (_jsxs(Stack, { flexDirection: "row", alignItems: "center", minWidth: 0, className: breadcrumbsButtonClasses.root, children: [_jsx(Button, { variant: "minimal", color: isSelected ? color : "disabled", slots: remainingSlots, className: clsx([breadcrumbsButtonClasses.button, className]), ...rest }), !hideSeparator && (_jsx(Separator, { color: isSelected ? color : "disabled", ...slotProps?.separator }))] })) }));
};
//# sourceMappingURL=BreadcrumbsButton.js.map